// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"eaaab92d","429":"2e34300d","488":"697fa38e","546":"f13c92b2"}[chunkId] + ".chunk.js";
};